import { render } from "./covedcheck.vue?vue&type=template&id=38f3d00f"
import script from "./covedcheck.vue?vue&type=script&lang=js"
export * from "./covedcheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__